import { UpdateDeal } from "src/features/deals/EditDealForm/types";
import { DealInformation } from "src/features/deals/DealDetails/types";
import { apiSlice } from "../lib/baseQuery";
import { DealsEndpointTags } from "./utils";
import { ConfirmedDeal } from "src/types/empresa";

const BASE_URL = "/api/deals";

export const dealsApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getDealInformationById: build.query<DealInformation, number>({
            query: (dealId: number) => BASE_URL + `/${dealId}`,
            providesTags: [DealsEndpointTags.GET_DEAL_INFO_BY_ID],
        }),
        createActiveDealManually: build.mutation<void, number>({
            query: (empresaId: number) => ({
                url: BASE_URL + `/${empresaId}`,
                method: "POST",
            }),
        }),
        getDealById: build.query<ConfirmedDeal, { empresaId: number, dealId: number }>({
            query: (request) => `/api/empresas/${request.empresaId}/deals/${request.dealId}`,
            keepUnusedDataFor: 0,
        }),
        updateDealInformation: build.mutation<void, Omit<UpdateDeal, "prospectadorId">>({
            query: (request) => ({
                url: `/api/deals/${request.id}`,
                method: "PUT",
                body: {
                    fechaInicio: request.fechaInicio,
                    fechaFin: request.fechaFin,
                },
            }),
            invalidatesTags: (_result, error, _arg, _meta) => error ? [] : [
                DealsEndpointTags.GET_DEAL_INFO_BY_ID
            ],
        }),
    }),
});

export const {
    useGetDealInformationByIdQuery,
    useCreateActiveDealManuallyMutation,
    useGetDealByIdQuery,
    useUpdateDealInformationMutation,
} = dealsApi;
